import React from "react";

import { adminFields, defaultAdminForm } from "../adminUtils";
import AdminTablePage from "../components/AdminTablePage";

const Admins = ({
  records,
  loading,
  error,
  onCreate,
  onUpdate,
  onDelete,
  onRefresh,
  page,
  pageSize,
  total,
  onPageChange,
  onSearch,
  currentAdminEmail,
  currentAdminId,
}) => (
  <AdminTablePage
    currentAdminEmail={currentAdminEmail}
    currentAdminId={currentAdminId}
    onSearch={onSearch}
    defaultForm={defaultAdminForm}
    error={error}
    fields={adminFields}
    loading={loading}
    onCreate={onCreate}
    onDelete={onDelete}
    onPageChange={onPageChange}
    onRefresh={onRefresh}
    onUpdate={onUpdate}
    page={page}
    pageSize={pageSize}
    records={records}
    subtitle="Manage admin accounts and access level."
    title="Admins"
    total={total}
    type="admins"
  />
);

export default Admins;
